import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'simpleNumber'
})
export class SimpleNumberPipe implements PipeTransform {

  private numbers = ["one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "zero"];

  transform(value: string): unknown {
    if (this.numbers.some(substring => value.toLowerCase().includes(substring))) {
      const replace = value.split(" ").find(partial => this.numbers.includes(partial.toLowerCase()));

      if (replace) {
        return value.replace(replace, `${SimpleNumberPipe.valToNumber(replace)}`);
      }
    }

    return value;
  }

  private static valToNumber(val: string): number {
    switch (val.toLowerCase()) {
      case "one":
        return 1;
      case "two":
        return 2;
      case "three":
        return 3;
      case "four":
        return 4;
      case "five":
        return 5;
      case "six":
        return 6;
      case "seven":
        return 7;
      case "eight":
        return 8;
      case "nine":
        return 9;
      case "ten":
        return 10;
      default:
        return 0;
    }
  }

}
